import { createReducer } from '@topconagriculture/frontend-utils';
import { setColumnConfig, setSelected, setSelectedAll } from './datatable.actions';
export const initialState = new Map();
export const dataTableReducer = createReducer(initialState, {
    [setColumnConfig.type]: (state, { payload }) => {
        if (!payload.tableId) {
            return state;
        }
        const tableStore = state[payload.tableId];
        const dataTableConfig = tableStore && tableStore.config;
        const columnConfig = dataTableConfig && dataTableConfig[payload.column.id];
        return {
            ...state,
            [payload.tableId]: {
                ...tableStore,
                config: {
                    ...dataTableConfig,
                    [payload.column.id]: {
                        ...columnConfig,
                        ...payload.column.config,
                    },
                },
            },
        };
    },
    [setSelected.type]: (state, { payload }) => {
        if (!payload.tableId) {
            return state;
        }
        return {
            ...state,
            [payload.tableId]: {
                ...state[payload.tableId],
                selected: payload.selected,
            },
        };
    },
    [setSelectedAll.type]: (state, { payload }) => {
        if (!payload.tableId) {
            return state;
        }
        return {
            ...state,
            [payload.tableId]: {
                ...state[payload.tableId],
                all: payload.all,
            },
        };
    },
});
export default { dataTable: dataTableReducer };
//# sourceMappingURL=datatable.reducer.js.map